// extracted by mini-css-extract-plugin
module.exports = {"photostoryCard":"xOTUQ","descriptionArea":"kesa3","count":"GfyXV","paraCaption":"rWkSP","readMore":"VUe0U","text":"COQxt","readMoreVisible":"Tfpz4"};